function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e327ba7c-0f39-4ff1-a2a4-d7deed7eafc4{mask:url(#a7c7704b-bee5-42aa-b8c1-06639d47cfab);filter:url(#ae18b34b-1890-4544-8eb6-99ba05ca2b9e);}.a947f473-e144-452d-8585-8c5daf72ff12,.ae0f861c-bf6f-4a6a-b796-f9edeec8800c,.b3a8fc54-2432-4623-ac95-b6eecdb2773c,.baec5230-f559-4c4a-9760-033aa445e344{mix-blend-mode:multiply;}.ae0f861c-bf6f-4a6a-b796-f9edeec8800c{fill:url(#a2d9b7f2-5148-4a9d-adba-6b7195f8b1a0);}.fc47cde0-ad5b-4b45-8f95-5f8fc035e58b{mask:url(#b1017534-c27b-4dbf-a0e6-b756a016409a);filter:url(#bb14591b-5bea-4127-92fa-e5c8515f085e);}.baec5230-f559-4c4a-9760-033aa445e344{fill:url(#a8d50318-1f63-41c3-b945-f77eeb4cd516);}.ebb70906-66b6-4193-96a0-1c404c7f472c{mask:url(#a187d88a-6465-4efb-a66b-95f46e8635ad);filter:url(#ac6d60b7-ba01-42ca-93b5-e7ac22531713);}.b3a8fc54-2432-4623-ac95-b6eecdb2773c{fill:url(#a1c0eb17-1da1-4c63-bfce-be6a38eb7fe9);}.ad4b28d6-5968-4ad3-9ef3-175d3b34f807{mask:url(#af801aff-e419-46f9-9976-2ea9770e86e5);filter:url(#b8fdc0f2-744c-4805-8913-9cb1ab9751bc);}.a947f473-e144-452d-8585-8c5daf72ff12{fill:url(#b11c1618-2751-491e-ada6-e1d76d1a5ae2);}.ad192494-a01a-48f5-aa6d-641df8c07ec2{fill:#282828;}.e0fb13f2-de06-49ce-a9c3-def56e118e39{mask:url(#f3b47c76-9fda-4427-b537-88127077dfb5);}.ba91b93f-801f-4fae-a4ec-00c3dfabed9b{fill:url(#ae9d91aa-8d37-452e-a89a-0299aa0686e0);}.bc4d2788-5102-474a-81e3-f19a155f594e{mask:url(#a8b6417b-30a7-433c-b886-819501b3b660);}.bccaae0d-dfe8-49ac-8656-51afbe81a3ce{fill:url(#e00dc337-c19c-46d0-b751-7d2da4b8dd2e);}.e1fd4a87-60a1-4765-b88b-c2803accf28d{mask:url(#bddf6fa6-47f6-4e6c-b826-0f82f40542c6);}.ab8233ea-574d-4fa6-9e15-d708fcbbe5ff{fill:url(#bc50c092-8b39-4399-bacd-6aa52decea9e);}.b251551d-8d60-40ca-a138-f86869e7e86e{mask:url(#a95be4c7-ed33-41a0-8077-c579efa7671a);}.a862a015-6638-4e2c-b6b0-d2fcff34bd96{fill:url(#bbbe975c-6fd0-4f30-9a08-b5b743c1bdaf);}.a1df5ee1-eb0e-4e09-980c-2e81b2a25e4b{fill:url(#a895b9f6-ef52-4c23-bdf6-3426355e2efd);}.e9632ee5-57db-4781-a4bf-efb311240533{fill:#f98585;}.a05a5889-48b3-4052-9941-893f2e31ee63{fill:#fcad81;}.b645f40b-7406-4a50-8fb5-1818104a0a5c{fill:#c2e877;}.f7251cda-c696-4d7a-865d-fd0276d1f611{fill:#74e2b5;}.bc4d426a-6198-4fd7-bc77-0bd9d71c65a5{filter:url(#a4459a6a-f09a-44c0-a8d8-c438763d9d5d);}.f58d98cd-59ea-4a6b-a743-1f1e7f0fee70{filter:url(#f2030343-b891-4283-8a78-5ad6b33cb350);}.e803bc05-f835-481f-b179-a14f1f851d8e{filter:url(#befa9475-a9e3-4662-a571-7e11312ce79c);}.b9669b98-9e25-4795-8f59-ca2dcdff3806{filter:url(#a2c7ac33-88fc-439b-9662-198e685d21c1);}"), /*#__PURE__*/React.createElement("filter", {
  id: "a2c7ac33-88fc-439b-9662-198e685d21c1",
  x: 149.74,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a7c7704b-bee5-42aa-b8c1-06639d47cfab",
  x: 149.74,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "b9669b98-9e25-4795-8f59-ca2dcdff3806"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a2d9b7f2-5148-4a9d-adba-6b7195f8b1a0",
  x1: 149.74,
  y1: 313.51,
  x2: 833.19,
  y2: 313.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#fafafa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#ededed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#d6d6d6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#b7b7b7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#8f8f8f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#5d5d5d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#242424"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1a1a1a"
})), /*#__PURE__*/React.createElement("filter", {
  id: "befa9475-a9e3-4662-a571-7e11312ce79c",
  x: 130.2,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "b1017534-c27b-4dbf-a0e6-b756a016409a",
  x: 130.2,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "e803bc05-f835-481f-b179-a14f1f851d8e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a8d50318-1f63-41c3-b945-f77eeb4cd516",
  x1: 130.2,
  y1: 313.51,
  x2: 813.65,
  y2: 313.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#fafafa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#ededed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#d6d6d6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#b7b7b7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#8f8f8f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#5e5e5e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#535353"
})), /*#__PURE__*/React.createElement("filter", {
  id: "f2030343-b891-4283-8a78-5ad6b33cb350",
  x: 110.66,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a187d88a-6465-4efb-a66b-95f46e8635ad",
  x: 110.66,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "f58d98cd-59ea-4a6b-a743-1f1e7f0fee70"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a1c0eb17-1da1-4c63-bfce-be6a38eb7fe9",
  x1: 110.66,
  y1: 313.51,
  x2: 794.12,
  y2: 313.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#fafafa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ededed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#d7d7d7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#b7b7b7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#8f8f8f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8c8c8c"
})), /*#__PURE__*/React.createElement("filter", {
  id: "a4459a6a-f09a-44c0-a8d8-c438763d9d5d",
  x: 91.12,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "af801aff-e419-46f9-9976-2ea9770e86e5",
  x: 91.12,
  y: -8577.29,
  width: 683.45,
  height: 32766,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "bc4d426a-6198-4fd7-bc77-0bd9d71c65a5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b11c1618-2751-491e-ada6-e1d76d1a5ae2",
  x1: 91.12,
  y1: 313.51,
  x2: 774.58,
  y2: 313.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#fafafa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#ededed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#d7d7d7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c6c6c6"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ae18b34b-1890-4544-8eb6-99ba05ca2b9e",
  x: 149.74,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "f3b47c76-9fda-4427-b537-88127077dfb5",
  x: 149.74,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "e327ba7c-0f39-4ff1-a2a4-d7deed7eafc4"
}, /*#__PURE__*/React.createElement("path", {
  className: "ae0f861c-bf6f-4a6a-b796-f9edeec8800c",
  d: "M480.45,507.72c-63.83-11.32-80.64-264.41-112.6-272-31.39-7.43-30.33,82.19-68.5,91.77-38.33,9.64-43.35-31-77.18-45.37-32.45-13.78-67.8,47.49-68.15,48.11a2.29,2.29,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.41,15,39.06,54,74.27,45.15,35.58-8.94,33.53-100.56,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,15.9-1.9,24.14,57.23,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25S755.5,370,762,333.72c5.67-31.45,10.57-58.61,24.64-62.75,31.83-9.41,20.18,39.66,45.46,55.95a2.29,2.29,0,1,1-2.48,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27.05,8-16,144.14-63.93,136.54-37.56-6-48.92-176.6-66.95-255.27-7-30.49-12.34-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C565.78,356.9,522.35,515.14,480.45,507.72Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ae9d91aa-8d37-452e-a89a-0299aa0686e0",
  x1: 149.74,
  y1: 313.51,
  x2: 833.19,
  y2: 313.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fc475d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#fc4c61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#fc596d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#fd6f81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fd7989"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bb14591b-5bea-4127-92fa-e5c8515f085e",
  x: 130.2,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a8b6417b-30a7-433c-b886-819501b3b660",
  x: 130.2,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "fc47cde0-ad5b-4b45-8f95-5f8fc035e58b"
}, /*#__PURE__*/React.createElement("path", {
  className: "baec5230-f559-4c4a-9760-033aa445e344",
  d: "M460.91,507.72c-63.83-11.32-80.63-264.41-112.6-272-31.38-7.43-30.33,82.19-68.5,91.77-38.35,9.64-43.32-31-77.18-45.37-32.45-13.77-67.79,47.49-68.15,48.11a2.29,2.29,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.42,15,39.06,54,74.27,45.15,35.59-8.94,33.53-100.56,70.68-91.78C385.81,239.91,403.6,503.4,464,503.4c35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,15.51-1.85,23.56,53.48,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25S736,370,742.5,333.72c5.67-31.45,10.57-58.61,24.64-62.75,31.83-9.4,20.18,39.65,45.46,55.95a2.29,2.29,0,1,1-2.48,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27,8-15.95,144.14-63.93,136.54-37.55-6-48.92-176.6-67-255.27-7-30.49-12.34-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C546.24,356.9,502.81,515.14,460.91,507.72Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e00dc337-c19c-46d0-b751-7d2da4b8dd2e",
  x1: 130.2,
  y1: 313.51,
  x2: 813.65,
  y2: 313.51,
  xlinkHref: "#ae9d91aa-8d37-452e-a89a-0299aa0686e0"
}), /*#__PURE__*/React.createElement("filter", {
  id: "ac6d60b7-ba01-42ca-93b5-e7ac22531713",
  x: 110.66,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "bddf6fa6-47f6-4e6c-b826-0f82f40542c6",
  x: 110.66,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "ebb70906-66b6-4193-96a0-1c404c7f472c"
}, /*#__PURE__*/React.createElement("path", {
  className: "b3a8fc54-2432-4623-ac95-b6eecdb2773c",
  d: "M441.37,507.72c-63.82-11.32-80.63-264.41-112.6-272-31.38-7.43-30.33,82.19-68.5,91.77-38.36,9.65-43.3-31-77.18-45.37-32.45-13.77-67.79,47.49-68.14,48.11a2.3,2.3,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.42,15,39.06,54,74.27,45.15,35.59-8.94,33.53-100.57,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.17-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,15.13-1.8,23,49.73,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25S716.42,370,723,333.72c5.67-31.45,10.57-58.61,24.64-62.75,31.84-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,0,1-2.49,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27,8-15.95,144.14-63.93,136.54-37.55-6-48.92-176.6-67-255.27-7-30.49-12.35-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C526.7,356.9,483.27,515.14,441.37,507.72Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bc50c092-8b39-4399-bacd-6aa52decea9e",
  x1: 110.66,
  y1: 313.51,
  x2: 794.12,
  y2: 313.51,
  xlinkHref: "#ae9d91aa-8d37-452e-a89a-0299aa0686e0"
}), /*#__PURE__*/React.createElement("filter", {
  id: "b8fdc0f2-744c-4805-8913-9cb1ab9751bc",
  x: 91.12,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a95be4c7-ed33-41a0-8077-c579efa7671a",
  x: 91.12,
  y: 119.05,
  width: 683.45,
  height: 388.92,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  className: "ad4b28d6-5968-4ad3-9ef3-175d3b34f807"
}, /*#__PURE__*/React.createElement("path", {
  className: "a947f473-e144-452d-8585-8c5daf72ff12",
  d: "M421.83,507.72c-63.82-11.32-80.63-264.41-112.6-272-31.38-7.43-30.33,82.19-68.5,91.77-38.38,9.65-43.27-31-77.17-45.37-32.45-13.77-67.8,47.49-68.15,48.11a2.3,2.3,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.93-50.06,35.41,15,39.05,54,74.26,45.15,35.6-8.94,33.53-100.57,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,14.75-1.74,22.41,46,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25s30.74-37.4,37.28-73.66c5.67-31.45,10.57-58.61,24.64-62.75,31.84-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,1,1-2.49,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27.05,8-16,144.14-63.92,136.54-37.56-6-48.93-176.6-67-255.27-7-30.49-12.35-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C507.16,356.9,463.73,515.14,421.83,507.72Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bbbe975c-6fd0-4f30-9a08-b5b743c1bdaf",
  x1: 91.12,
  y1: 313.51,
  x2: 774.58,
  y2: 313.51,
  xlinkHref: "#ae9d91aa-8d37-452e-a89a-0299aa0686e0"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a895b9f6-ef52-4c23-bdf6-3426355e2efd",
  x1: 71.59,
  y1: 313.51,
  x2: 755.04,
  y2: 313.51,
  xlinkHref: "#ae9d91aa-8d37-452e-a89a-0299aa0686e0"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fe95e1bc-a008-4adf-b7d2-b1e3a28c381f",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "b2e220fb-89d1-492f-82a4-eff77fe16b77",
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "ad192494-a01a-48f5-aa6d-641df8c07ec2",
  cx: 430.58,
  cy: 336.5,
  r: 336.5
}), /*#__PURE__*/React.createElement("g", {
  className: "e0fb13f2-de06-49ce-a9c3-def56e118e39"
}, /*#__PURE__*/React.createElement("path", {
  className: "ba91b93f-801f-4fae-a4ec-00c3dfabed9b",
  d: "M480.45,507.72c-63.83-11.32-80.64-264.41-112.6-272-31.39-7.43-30.33,82.19-68.5,91.77-38.33,9.64-43.35-31-77.18-45.37-32.45-13.78-67.8,47.49-68.15,48.11a2.29,2.29,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.41,15,39.06,54,74.27,45.15,35.58-8.94,33.53-100.56,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,15.9-1.9,24.14,57.23,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25S755.5,370,762,333.72c5.67-31.45,10.57-58.61,24.64-62.75,31.83-9.41,20.18,39.66,45.46,55.95a2.29,2.29,0,1,1-2.48,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27.05,8-16,144.14-63.93,136.54-37.56-6-48.92-176.6-66.95-255.27-7-30.49-12.34-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C565.78,356.9,522.35,515.14,480.45,507.72Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "bc4d2788-5102-474a-81e3-f19a155f594e"
}, /*#__PURE__*/React.createElement("path", {
  className: "bccaae0d-dfe8-49ac-8656-51afbe81a3ce",
  d: "M460.91,507.72c-63.83-11.32-80.63-264.41-112.6-272-31.38-7.43-30.33,82.19-68.5,91.77-38.35,9.64-43.32-31-77.18-45.37-32.45-13.77-67.79,47.49-68.15,48.11a2.29,2.29,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.42,15,39.06,54,74.27,45.15,35.59-8.94,33.53-100.56,70.68-91.78C385.81,239.91,403.6,503.4,464,503.4c35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,15.51-1.85,23.56,53.48,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25S736,370,742.5,333.72c5.67-31.45,10.57-58.61,24.64-62.75,31.83-9.4,20.18,39.65,45.46,55.95a2.29,2.29,0,1,1-2.48,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27,8-15.95,144.14-63.93,136.54-37.55-6-48.92-176.6-67-255.27-7-30.49-12.34-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C546.24,356.9,502.81,515.14,460.91,507.72Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "e1fd4a87-60a1-4765-b88b-c2803accf28d"
}, /*#__PURE__*/React.createElement("path", {
  className: "ab8233ea-574d-4fa6-9e15-d708fcbbe5ff",
  d: "M441.37,507.72c-63.82-11.32-80.63-264.41-112.6-272-31.38-7.43-30.33,82.19-68.5,91.77-38.36,9.65-43.3-31-77.18-45.37-32.45-13.77-67.79,47.49-68.14,48.11a2.3,2.3,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.42,15,39.06,54,74.27,45.15,35.59-8.94,33.53-100.57,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.17-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,15.13-1.8,23,49.73,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25S716.42,370,723,333.72c5.67-31.45,10.57-58.61,24.64-62.75,31.84-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,0,1-2.49,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27,8-15.95,144.14-63.93,136.54-37.55-6-48.92-176.6-67-255.27-7-30.49-12.35-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C526.7,356.9,483.27,515.14,441.37,507.72Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "b251551d-8d60-40ca-a138-f86869e7e86e"
}, /*#__PURE__*/React.createElement("path", {
  className: "a862a015-6638-4e2c-b6b0-d2fcff34bd96",
  d: "M421.83,507.72c-63.82-11.32-80.63-264.41-112.6-272-31.38-7.43-30.33,82.19-68.5,91.77-38.38,9.65-43.27-31-77.17-45.37-32.45-13.77-67.8,47.49-68.15,48.11a2.3,2.3,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.93-50.06,35.41,15,39.05,54,74.26,45.15,35.6-8.94,33.53-100.57,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,14.75-1.74,22.41,46,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25s30.74-37.4,37.28-73.66c5.67-31.45,10.57-58.61,24.64-62.75,31.84-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,1,1-2.49,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27.05,8-16,144.14-63.92,136.54-37.56-6-48.93-176.6-67-255.27-7-30.49-12.35-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C507.16,356.9,463.73,515.14,421.83,507.72Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "a1df5ee1-eb0e-4e09-980c-2e81b2a25e4b",
  d: "M402.29,507.72c-63.82-11.32-80.63-264.41-112.59-272-31.39-7.43-30.34,82.19-68.51,91.77-38.4,9.66-43.25-31-77.17-45.37-32.45-13.77-67.8,47.49-68.15,48.11a2.29,2.29,0,0,1-4-2.27c1.52-2.68,37.75-65.41,73.92-50.06,35.41,15,39.05,54,74.26,45.15,35.6-8.94,33.53-100.57,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.17-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,14.36-1.69,21.83,42.23,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25s30.74-37.39,37.28-73.66c5.67-31.45,10.57-58.61,24.64-62.75,31.85-9.4,20.17,39.65,45.47,55.95a2.29,2.29,0,0,1-2.48,3.85c-27.07-17.44-15.49-63.13-41.7-55.41-27,8-15.94,144.14-63.92,136.54-37.56-6-48.92-176.6-67-255.27-7-30.49-12.35-33.22-14.3-33-12,1.44-44.12,119.74-48.55,135C487.62,356.9,444.19,515.14,402.29,507.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e9632ee5-57db-4781-a4bf-efb311240533",
  d: "M385.14,507.78c-64.13-8.48-81.29-264.45-113.34-272-31.39-7.43-30.33,82.19-68.51,91.77-38.41,9.66-43.22-31-77.17-45.37C93.67,268.38,58.32,329.64,58,330.26A2.29,2.29,0,0,1,54,328c1.52-2.68,37.75-65.41,73.92-50.06,35.41,15,39.06,54,74.27,45.15,35.58-8.94,33.53-100.56,70.67-91.78,36.45,8.61,54.23,272.1,114.6,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.4-138.28,14.37-1.69,21.83,42.23,33.84,120,11.3,73.31,25.38,164.55,48.68,168.25S659.45,370,666,333.72c5.67-31.45,10.56-58.61,24.63-62.75,31.85-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,0,1-2.48,3.85c-27.06-17.44-15.49-63.13-41.69-55.41-27,8-15.95,144.14-63.93,136.54-37.56-6-48.92-176.6-67-255.27-7-30.49-12.36-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C468.37,361.6,426.21,513.34,385.14,507.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a05a5889-48b3-4052-9941-893f2e31ee63",
  d: "M368,507.85c-64.44-5.66-81.94-264.5-114.08-272.1-31.38-7.43-30.33,82.19-68.5,91.77-38.43,9.66-43.21-30.95-77.18-45.37-32.44-13.77-67.79,47.49-68.14,48.11a2.3,2.3,0,0,1-4-2.27c1.53-2.68,37.76-65.41,73.92-50.06,35.41,15,39.07,54,74.27,45.15,35.57-8.93,33.54-100.56,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.41-138.28,14.38-1.69,21.83,42.23,33.83,120,11.31,73.31,25.38,164.55,48.68,168.25s30.74-37.4,37.28-73.66c5.67-31.45,10.57-58.61,24.64-62.75,31.84-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,0,1-2.49,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27,8-15.95,144.14-63.93,136.54-37.55-6-48.92-176.6-67-255.27-7-30.49-12.36-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C449.11,366.3,408.23,511.55,368,507.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b645f40b-7406-4a50-8fb5-1818104a0a5c",
  d: "M350.82,507.91C286.08,505.08,268.23,243.37,236,235.75c-31.39-7.44-30.33,82.19-68.51,91.77-38.45,9.66-43.18-30.94-77.17-45.37-32.45-13.77-67.8,47.49-68.15,48.11a2.29,2.29,0,0,1-4-2.27c1.52-2.68,37.76-65.41,73.92-50.06,35.4,15,39.07,54,74.26,45.15,35.57-8.93,33.55-100.55,70.68-91.78,36.44,8.61,54.23,272.1,114.59,272.1,35.08,0,76.17-141.86,106.34-246,26-89.85,40.19-136.81,52.41-138.28,14.39-1.69,21.83,42.23,33.83,120,11.31,73.31,25.39,164.55,48.69,168.25s30.74-37.4,37.27-73.66c5.68-31.45,10.57-58.61,24.64-62.75,31.83-9.4,20.18,39.65,45.47,55.95a2.29,2.29,0,0,1-2.48,3.85c-27.07-17.44-15.49-63.13-41.69-55.41-27,8-16,144.14-63.93,136.54-37.56-6-48.92-176.6-67-255.27-7-30.49-12.35-33.22-14.29-33-12,1.44-44.13,119.74-48.56,135C429.85,371,390.25,509.76,350.82,507.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f7251cda-c696-4d7a-865d-fd0276d1f611",
  d: "M333.66,508c-65,0-83.24-264.59-115.55-272.23-31.39-7.44-30.33,82.19-68.51,91.77-38.46,9.67-43.15-30.93-77.17-45.37C40,268.37,4.64,329.64,4.28,330.26A2.29,2.29,0,0,1,.3,328c1.52-2.68,37.76-65.41,73.92-50.06,35.4,15,39.07,54,74.27,45.15C184,314.15,182,222.54,219.16,231.3c36.45,8.61,54.24,272.1,114.6,272.1,35.07,0,76.16-141.86,106.34-246,26-89.85,40.18-136.81,52.4-138.28,14.4-1.69,21.83,42.23,33.84,120,11.31,73.31,25.38,164.55,48.68,168.25s30.74-37.4,37.28-73.66c5.67-31.45,10.56-58.61,24.63-62.75,31.84-9.41,20.19,39.66,45.47,55.95a2.29,2.29,0,1,1-2.48,3.85c-27.06-17.44-15.48-63.13-41.69-55.41-27.05,8-16,144.14-63.93,136.54-37.56-6-48.92-176.6-66.95-255.27-7-30.49-12.36-33.22-14.3-33-12,1.44-44.13,119.74-48.55,135C410.59,375.69,372.27,508,333.66,508Z"
})));

const SvgLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 833.19 673",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.0597d2c7.svg";
export { ForwardRef as ReactComponent };